'use strict';

import BiBaseDataItem from './bi-base-item';

/**
 * Represents the "load phase" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13
 *
 * It should be used to monitor custom application load phases.
 */
export default class BiLoadPhaseDataItem extends BiBaseDataItem {
  constructor(sessionId) {
    super(13, sessionId);
  }
}



// WEBPACK FOOTER //
// ./data-items/bi-load-phase-item.js